export default __webpack_public_path__ + "static/icon-0b3d73c632ab9f6d8c99005007c0848d.png";